/* eslint-disable react/no-array-index-key */
import icon1 from '../../../assets/images/svg/customers-rosepink.svg';
import icon2 from '../../../assets/images/svg/doctor-tiffanyblue.svg';
import icon3 from '../../../assets/images/svg/doctor-appointment-yellow.svg';
import ContentWithIconBox from '../../../Components/contentWithIconBox/ContentWithIconBox';
import './howItWorks.css';

function HowItWorks() {
  return (
    <section className="howItWorks">
      <ContentWithIconBox
        heading="How it works"
        desc="Meri Sheet is the leading healthcare technology company in Pakistan and today we help 2 crore customers every month."
        iconBoxes={[
          {
            icon: icon1,
            title: 'Click on instant consultation or go via Health Check'
          },
          {
            icon: icon2,
            title: 'Connect on an Audio/ video call with a verified doctor'
          },
          {
            icon: icon3,
            title: 'Get a digital prescription & a free follow-up'
          }
        ]}
      />
    </section>
  );
}

export default HowItWorks;
